import React from "react";
import { CheckIcon, CreditCardIcon, FileTextIcon, GiftIcon, PrinterIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHead } from "./SectionHead";
import { CHECKOUT_URL, bonuses, offerIncludes, product } from "../data/landing";
import { trackPixelEvent } from "../utils/metaPixel";
const deliveryItems = [{
  icon: FileTextIcon,
  label: "Digital PDF bundle"
}, {
  icon: PrinterIcon,
  label: "Printable worksheets"
}, {
  icon: CreditCardIcon,
  label: "One-time payment"
}];
export function OfferSection() {
  return <section id="offer-details" className="scroll-mt-16 bg-navy py-16 md:py-24" data-id="element-62" data-mp="mgwk5ag6pwfl">
      <div className="mx-auto max-w-[1180px] px-5 sm:px-8" data-id="element-63" data-mp="reg1ij86ipbr">
        <SectionHead tone="dark" eyebrow="Everything in one kit" title="Get New Manager" highlight="Essentials" data-id="element-64" data-mp="wd9dg77ti89t" />

        <div className="mx-auto max-w-[600px] rounded-lg bg-white px-5 py-8 shadow-[0_30px_70px_rgba(0,0,0,0.35)] sm:px-10 sm:py-10" data-id="element-65" data-mp="2t6b66ew0ptkh">
          <div className="text-center" data-id="element-66" data-mp="2y6gqtb3veft2">
            <span className="inline-block rounded-sm bg-soft px-3 py-1 text-[11px] font-bold uppercase tracking-[0.16em] text-navy" data-id="element-67" data-mp="12o1vx48zn48k">
              Volume 01 · 10 workshops + 5 bonuses
            </span>
            <img src={product.mockup} alt="New Manager Essentials box set" width={1024} height={1536} loading="lazy" className="mx-auto mt-6 h-[280px] w-auto rounded-xl shadow-[0_16px_36px_rgba(19,34,56,0.18)]" data-id="element-68" data-mp="sx747kcz3cfq" />
            <h3 className="mt-6 font-display text-[34px] font-extrabold uppercase leading-none text-navy sm:text-[40px]" data-id="element-69" data-mp="1gn1fvylk2uye">
              {product.name}
            </h3>
            <p className="mx-auto mt-3 max-w-[440px] text-[15px] text-ink/80" data-id="element-70" data-mp="17mlf4ww761x8">
              A 40-page facilitator playbook with 10 complete workshops for first-time managers, plus 5 bonus resources.
            </p>
          </div>

          <div className="my-7 border-t border-line" data-id="element-71" data-mp="3sbsr3ufqgb91" />

          <h4 className="text-center text-xs font-bold uppercase tracking-[0.16em] text-navy" data-id="element-72" data-mp="3sf6r4w0xc8db">What's included</h4>
          <ul className="mt-5 grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-73" data-mp="2ng946i1xiet">
            {offerIncludes.map(item => <li key={item} className="flex items-center gap-2.5 text-[15px] font-medium text-ink" data-id="element-74" data-mp="3ks9pe6ypltb4">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal-wash" data-id="element-75" data-mp="3otvagfleddwe">
                  <CheckIcon className="h-3 w-3 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-76" data-mp="3b2q835qna7id" />
                </span>
                {item}
              </li>)}
          </ul>

          <h4 className="mt-7 text-center text-xs font-bold uppercase tracking-[0.16em] text-navy" data-id="element-77" data-mp="316dcg2bjhjkz">
            Plus {bonuses.length} bonuses
          </h4>
          <ul className="mt-4 space-y-2.5" data-id="element-78" data-mp="2s4nml0xb2spb">
            {bonuses.map(bonus => <li key={bonus.title} className="flex items-center gap-2.5 text-[15px] font-medium text-ink" data-id="element-79" data-mp="2s6qke74p9q4l">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal-wash" data-id="element-80" data-mp="2x5jt7m91ksyf">
                  <GiftIcon className="h-3 w-3 text-teal" aria-hidden="true" data-id="element-81" data-mp="28j3vp8r0tin7" />
                </span>
                {bonus.title}
              </li>)}
          </ul>

          <div className="my-7 border-t border-line" data-id="element-82" data-mp="2mgacwyw3j9ab" />

          <div className="text-center" data-id="element-83" data-mp="2ifywxzeohx56">
            <p className="flex items-end justify-center font-display font-extrabold leading-none text-navy" data-id="element-84" data-mp="2ijeb900j325j">
              <span className="mb-2 text-4xl" data-id="element-85" data-mp="2rhpyqt63ljtr">$</span>
              <span className="text-[96px] tracking-[-0.02em]" data-id="element-86" data-mp="2rgx0yhp4a4nr">{product.price}</span>
              <span className="mb-3 ml-2 font-sans text-sm font-medium text-muted" data-id="element-87" data-mp="365kr28g71m6b">{product.currency}</span>
            </p>
            <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs font-bold uppercase tracking-[0.14em] text-muted" data-id="element-88" data-mp="3181dzbv8fffy">
              <span data-id="element-89" data-mp="3a87qovj3wbe2">One-time payment</span>
              <span data-id="element-90" data-mp="3a9irqnl6351h">Digital PDF</span>
            </div>
          </div>

          <CtaButton href={CHECKOUT_URL} onClick={() => trackPixelEvent("InitiateCheckout", {
          value: Number(product.price),
          currency: product.currency,
          content_name: product.name
        })} className="mt-7 w-full whitespace-normal" data-id="element-91" data-mp="18jjx7h642ft4">
            Get New Manager Essentials
          </CtaButton>

          <div className="mt-8 border-t border-line pt-5" data-id="element-92" data-mp="pl7kjlfzqnss">
            <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-[13px] font-medium text-muted" data-id="element-93" data-mp="uj92g31okh2o">
              {deliveryItems.map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex items-center gap-1.5" data-id="element-94" data-mp="ymyu51dnjerx">
                  <Icon className="h-4 w-4 text-teal" aria-hidden="true" data-id="element-95" data-mp="13kqm1vear0w4" />
                  {label}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-6 max-w-[600px] text-center text-[13px] text-white/70" data-id="element-96" data-mp="2ey2qo8hvrnjc">
          Price shown in USD. Editable presentation decks are not included.
        </p>
      </div>
    </section>;
}